import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useNavigate } from 'react-router-dom'
function CreateEmail() {
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        e.preventDefault()
        navigate('/email/preview')
    }
    const handleBack = () => {
        navigate('/blast/email')
    }
  return (
   <>
    <SubHeader title="Create New Email Blast" description={"Communicate with patient using email."} >
        <div className="d-flex justify-content-end">
            <button className="btn btn-light-info" onClick={handleBack}>Back</button>
        </div>
        </SubHeader>
    <div className="row">
        <div className="col-4">
                <div className="card">
                    <div className="card-body">

                        <ul className="nav flex-column">
                            <li className="nav-item">
                                <div className="d-flex justify-content-start align-items-center">
                                     <button className="btn btn-icon btn-primary me-3">1</button>
                                     <div className="d-flex flex-column">
                                         <span className="fw-bold fs-4">Campaign Information</span>
                                         <span className="text-muted">Basic information</span>
                                     </div>
                                </div>
                                <div className='ms-6 h-40px border-gray-400 ' style={{ borderLeft: '1px solid black'}}></div>
                            </li>
                            <li className="nav-item">
                                <div className="d-flex justify-content-start align-items-center">
                                     <button className="btn btn-icon btn-primary disabled me-3">2</button>
                                     <div className="d-flex flex-column">
                                         <span className="fw-bold fs-4 text-muted">Subject Line</span>
                                         <span className="text-muted">Subject Line for Email</span>
                                     </div>
                                </div>
                                <div className='ms-6 h-40px border-gray-400 ' style={{ borderLeft: '1px solid black'}}></div>
                            </li>
                            <li className="nav-item">
                                <div className="d-flex justify-content-start align-items-center">
                                     <button className="btn btn-icon btn-primary disabled me-3">3</button>
                                     <div className="d-flex flex-column">
                                         <span className="fw-bold fs-4 text-muted">Content</span>
                                         <span className="text-muted">Main content of the email</span>
                                     </div>
                                </div>
                                <div className='ms-6 h-40px border-gray-400 ' style={{ borderLeft: '1px solid black'}}></div>
                            </li>
                            <li className="nav-item">
                                <div className="d-flex justify-content-start align-items-center">
                                     <button className="btn btn-icon btn-primary disabled me-3">4</button>
                                     <div className="d-flex flex-column">
                                         <span className="fw-bold fs-4 text-muted">Patient List</span>
                                         <span className="text-muted">Select patient that will receive email.</span>
                                     </div>
                                </div>
                                <div className='ms-6 h-40px border-gray-400 ' style={{ borderLeft: '1px solid black'}}></div>
                            </li>
                            <li className="nav-item">
                                <div className="d-flex justify-content-start align-items-center">
                                     <button className="btn btn-icon btn-primary disabled me-3">5</button>
                                     <div className="d-flex flex-column">
                                         <span className="fw-bold fs-4 text-muted">Complete</span>
                                         <span className="text-muted">Process the Campaign</span>
                                     </div>
                                </div>
                            </li>
                        </ul>

                       
                    </div>
                </div>
        </div>
        <div className="col-8">
                <div className="card h-100">
                    <div className="card-body">
                        <div className="w-100">
                            <div className="pb-10 pb-lg-15">
                                <h2 className="fw-bold d-flex-align-items-center text-gray-900">
                                    Enter Campaign Information
                                </h2>
                                <div className="text-muted fw-semibold fs-6">
                                    This information is for internal use and to identify the campaign.
                                </div>
                            </div>
                        </div>
                        <div className='d-flex.flex-column.align-items-center mt-4'>
                            <div className="mb-4 row">
                                <label className="col-sm-3 col-form-label">Campaign Name</label>
                                <div className="col-sm-9">
                                    <input type="text" className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="mb-4 row">
                                <label className="col-sm-3 col-form-label">Short Description</label>
                                <div className="col-sm-9">
                                    <input type="text" className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <button className="btn btn-light-primary">Next</button>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </div>
   </>
  )
}

export default CreateEmail